import { postRequest, processError } from "../../utils/apiHandlers";
import { LOADING_STATE, LS_ITEM, NOTIF_TYPE } from "../../utils/stateTypes";
import _notif from "../notification";

/* =========================== CONTACT =========================== */

export const sendContactMessage = (message, successCB) => (
  (dispatch) => {
    const lsItem = LS_ITEM.CONTACT_SEND;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    postRequest("/Contact/SendContactMessage",
      message,
      () => {
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
        dispatch(_notif.actions.queueNotification("Thank you - your message has been sent.", NOTIF_TYPE.SUCCESS));
        successCB();
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);
